/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import BackButton from "../../../components/BackButton";
import Card from "../../../components/Card";
import SubMenu from "../../../components/SubMenu";
import Layout from "../../../layout";
import CustomButton from "../../../components/CustomButton";
import Checked from "../../../assets/icons/Checked.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubscriptionsConfig,
  getMySubscriptions,
  getPendingPlacementFees,
  createSubscription,
} from "../../../redux/actions/subscriptionActions";
import {
  getJobSeekerPlans,
  getMyJobSeekerSubscription,
  subscribeToJobSeekerPlan,
  cancelJobSeekerSubscription,
} from "../../../redux/actions/jobSeekerSubscriptionActions";
import { SectionLoader } from "../../../components/PageLoader";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";
import httpRequest from "../../../ajax";
import { getCurrencySymbol } from "../../../utils/helpers";
import cogoToast from "cogo-toast";
import { Divider } from "@material-ui/core";

const subMenuOptions = [
  // ["Post-A-Job", "/subscriptions/post-job"],
  // ["Placement Fee", "/subscriptions/placement-fee"],
  // ["Recruiters", "/subscriptions/recruiters"],
  ["Active Subscriptions", "/subscriptions/active"],
  ["Invoice", "/subscriptions/invoice"],
];

/* ─── inline styles ─────────────────────────────────────────── */
const styles = {
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    borderRadius: "10px",
    border: "1px solid #E8ECF0",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "'DM Sans', sans-serif",
  },
  thead: {
    backgroundColor: "#F7F9FB",
  },
  th: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#8A96A3",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    padding: "12px 16px",
    textAlign: "left",
    borderBottom: "1px solid #E8ECF0",
    whiteSpace: "nowrap",
  },
  td: {
    fontSize: "13px",
    fontWeight: "500",
    color: "#1E2329",
    padding: "14px 16px",
    borderBottom: "1px solid #F0F3F6",
    verticalAlign: "middle",
  },
  tdSub: {
    fontSize: "12px",
    fontWeight: "400",
    color: "#6B7785",
    padding: "14px 16px",
    borderBottom: "1px solid #F0F3F6",
    verticalAlign: "middle",
  },
  trHover: {
    cursor: "pointer",
    transition: "background 0.15s",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "14px 20px",
    borderBottom: "1px solid #E8ECF0",
    background: "linear-gradient(90deg, #F7F9FB 0%, #fff 100%)",
    borderRadius: "10px 10px 0 0",
  },
  sectionHeaderDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "#3A6ED4",
    flexShrink: 0,
  },
  sectionHeaderText: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#1E2329",
    letterSpacing: "0.02em",
  },
  sectionBody: {
    background: "#fff",
    borderRadius: "0 0 10px 10px",
    padding: "20px",
  },
  placementCard: {
    background: "#fff",
    border: "1px solid #E8ECF0",
    borderRadius: "10px",
    padding: "20px",
    marginBottom: "16px",
  },
  placementLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#8A96A3",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "2px",
  },
  placementValue: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#1E2329",
    margin: 0,
  },
  badge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: "20px",
    fontSize: "10px",
    fontWeight: "700",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    background: "#FFF3CD",
    color: "#8B6200",
    border: "1px solid #FFD875",
  },
  freeCard: {
    background: "linear-gradient(135deg, #EEF4FF 0%, #F7F9FF 100%)",
    border: "1px solid #D0DEFF",
    borderRadius: "10px",
    padding: "20px 24px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  freeIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    background: "#3A6ED4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  recruiterCard: {
    background: "#F7F9FB",
    border: "1px solid #E8ECF0",
    borderRadius: "10px",
    padding: "18px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
    marginTop: "16px",
  },
  checkedRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginTop: "16px",
    background: "#F7F9FB",
    border: "1px solid #E8ECF0",
    borderRadius: "8px",
    padding: "14px 16px",
    fontSize: "12px",
    color: "#4A5568",
    lineHeight: "1.6",
  },
  container: {
    fontFamily: "'DM Sans', sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "24px",
  },
  headerTitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1E2329",
    margin: 0,
  },
  dashboardCard: {
    background: "#fff",
    border: "1px solid #E8ECF0",
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "20px",
  },
  dashboardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "16px",
    borderBottom: "1px solid #E8ECF0",
  },
  dashboardPlanName: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  proBadge: {
    background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
    color: "#fff",
    fontSize: "10px",
    fontWeight: "700",
    padding: "4px 12px",
    borderRadius: "20px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  billingInfo: {
    background: "#F7F9FB",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "20px",
  },
  billingLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#8A96A3",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "4px",
  },
  billingValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1E2329",
    margin: 0,
  },
  benefitsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "20px",
  },
  benefitCard: {
    background: "#F7F9FB",
    border: "1px solid #E8ECF0",
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  benefitIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    background: "#D1FAE5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  benefitText: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#1E2329",
  },
  creditsDisplay: {
    background: "linear-gradient(135deg, #EEF4FF 0%, #F7F9FF 100%)",
    border: "1px solid #D0DEFF",
    borderRadius: "10px",
    padding: "20px",
    textAlign: "center",
    marginBottom: "20px",
  },
  creditsNumber: {
    fontSize: "36px",
    fontWeight: "700",
    color: "#3A6ED4",
    margin: "0 0 4px 0",
  },
  creditsLabel: {
    fontSize: "12px",
    color: "#6B7785",
    margin: 0,
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
  },
  cancelModal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  cancelModalContent: {
    background: "#fff",
    borderRadius: "12px",
    padding: "32px",
    maxWidth: "480px",
    width: "90%",
  },
  cancelModalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1E2329",
    margin: "0 0 12px 0",
  },
  cancelModalBody: {
    fontSize: "14px",
    color: "#4A5568",
    lineHeight: "1.6",
    marginBottom: "24px",
  },
  cancelModalActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
  },
};

const SectionHeader = ({ text }) => (
  <div style={styles.sectionHeader}>
    <div style={styles.sectionHeaderDot} />
    <span style={styles.sectionHeaderText}>{text}</span>
  </div>
);

const mapInvoicePaymentTypeLabel = (paymentType) => {
  switch (paymentType) {
    case "initial":
      return "Part Payment";
    case "final":
      return "Full Payment";
    case "job_seeker_subscription":
      return "Workbrook Pro";
    case "ppv":
      return "Pay per view";
    case "per_view":
      return "Per view";
    default:
      return paymentType || "—";
  }
};

const invoiceJobTitleCell = (item) => {
  if (item.role_title) return item.role_title;
  if (item.subscription_plan_name) return item.subscription_plan_name;
  if (item.payment_type === "job_seeker_subscription") return "Workbrook Pro subscription";
  return "—";
};

/* ─── component ─────────────────────────────────────────────── */
const Subscriptions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  // Redirect base /subscriptions to /subscriptions/active
  useEffect(() => {
    if (pathname === "/subscriptions") {
      history.replace("/subscriptions/active");
    }
  }, [pathname, history]);
  const [loading, setLoading] = useState(false);
  const { availableSubsreiptions, pendingPlacementFees } = useSelector(
    ({ subscription }) => subscription
  );
  const { userData } = useSelector((state) => state.auth);

  const [recruiterSubscriptions, setRecruiterSubscriptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [invoicePage, setInvoicePage] = useState(1);
  const [invoiceTotalPages, setInvoiceTotalPages] = useState(1);
  const [invoiceListFilter, setInvoiceListFilter] = useState("all");
  const invoicePerPage = 10;

  const { plans, mySubscription } = useSelector(
    (state) => state.jobSeekerSubscription || {},
  );
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const [subscribing, setSubscribing] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const currencySymbol = getCurrencySymbol(userData?.country);

  const getDisplayPrice = (plan) => {
    if (!plan) return "0";
    if (currencySymbol === "₦") {
      return parseFloat(plan.price_ngn || 0).toLocaleString();
    }
    return parseFloat(plan.price_usd || 0).toFixed(2);
  };

  const handleSubscribePlan = async (planId) => {
    setSubscribing(true);
    try {
      const result = await subscribeToJobSeekerPlan(dispatch, {
        plan_id: planId,
        payment_method: "wallet",
      });

      if (result?.payload?.status) {
        await getMyJobSeekerSubscription(dispatch);
        cogoToast.success("Successfully subscribed!");
      } else if (result?.payload?.code === "insufficient_balance") {
        setShowFundWalletModal(true);
      } else {
        cogoToast.error(
          result?.payload?.message || "Subscription failed. Please try again.",
        );
      }
    } catch (err) {
      console.error("Subscription error:", err);
      cogoToast.error("An error occurred. Please try again.");
    } finally {
      setSubscribing(false);
    }
  };

  const handleCancel = async () => {
    setCancelling(true);
    try {
      const result = await cancelJobSeekerSubscription(dispatch);

      if (result?.payload?.status) {
        await getMyJobSeekerSubscription(dispatch);
        setShowCancelModal(false);
        cogoToast.success(
          "Subscription cancelled. You'll retain access until the end of your billing period.",
        );
      } else {
        cogoToast.error(result?.payload?.message || "Cancellation failed.");
      }
    } catch (err) {
      console.error("Cancellation error:", err);
      cogoToast.error("An error occurred. Please try again.");
    } finally {
      setCancelling(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  useEffect(() => {
    setLoading(true);
    if (pathname.includes("placement-fee")) {
      Promise.resolve(getPendingPlacementFees(dispatch, currentPage)).then(() =>
        setLoading(false)
      );
    } else {
      Promise.resolve(
        getSubscriptionsConfig(dispatch),
        getMySubscriptions(dispatch),
        getJobSeekerPlans(dispatch),
        getMyJobSeekerSubscription(dispatch)
      ).then(() => setLoading(false));
    }
    if (pathname.includes("invoice")) {
      setShowInvoiceModal(true);
    } else {
      setShowInvoiceModal(false);
    }
    const fetchInvoices = async () => {
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
        let query = `page=${invoicePage}&per_page=${invoicePerPage}`;
        if (invoiceListFilter === "subscription") {
          query += "&payment_type=job_seeker_subscription";
        } else if (invoiceListFilter === "placement") {
          query += "&payment_type=placement";
        }
        const response = await httpRequest("get", `/jobs/invoices?${query}`);
        if (response?.data?.status && response?.data?.data) {
          const apiData = response.data.data;

          if (apiData.invoices) {
            const transformed = apiData.invoices.map((item) => ({
              id: item.id,
              invoice_number: item.invoice_number,
              jobtitle: invoiceJobTitleCell(item),
              status:
                item.status.charAt(0).toUpperCase() + item.status.slice(1),
              payment_type: mapInvoicePaymentTypeLabel(item.payment_type),
            }));
            setInvoices(transformed);
          }

          const totalPages =
            apiData.total_pages ||
            apiData.last_page ||
            (apiData.total && apiData.per_page
              ? Math.ceil(apiData.total / apiData.per_page)
              : 1);
          setInvoiceTotalPages(totalPages);
        }
      } catch (error) {
        console.error("Failed to fetch invoices:", error);
      }
    };
    if (pathname.includes("invoice")) {
      fetchInvoices();
    }
  }, [dispatch, pathname, currentPage, invoicePage, invoiceListFilter]);

  const handleSubscribe = (configId) => {
    const payload = {
      subscription_config_id: parseInt(configId),
      isPaymentFromWallet: 1,
      card_id: 0,
    };
    setLoading(true);
    Promise.resolve(createSubscription(dispatch, { ...payload })).then(() =>
      setLoading(false)
    );
  };

  const handleRowClick = (id) => {
    history.push(`/subscriptions/invoice/${id}`);
  };

  useEffect(() => {
    const jobArray = [];
    const recruiterArray = [];
    if (availableSubsreiptions && availableSubsreiptions[0]) {
      availableSubsreiptions.forEach((subscription) => {
        if (subscription.category === "Recruiter") {
          recruiterArray.push(subscription);
        } else {
          jobArray.push(subscription);
        }
      });
      setRecruiterSubscriptions(recruiterArray);
    }
  }, [availableSubsreiptions]);

  const handlePayNow = async (recruitment) => {
    try {
      setIsLoading(true);
      const response = await httpRequest("post", "/jobs/pay_placement_fee", {
        candidate_recruitment_id: recruitment.id,
      });
      if (response.data.success) {
        await getPendingPlacementFees(dispatch, currentPage);
      }
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleInvoicePageChange = (page) => {
    setInvoicePage(page);
  };

  /* status pill colours */
  const statusStyle = (status) => {
    const s = (status || "").toLowerCase();
    if (s === "paid")
      return { background: "#D1FAE5", color: "#065F46", border: "1px solid #6EE7B7" };
    if (s === "pending")
      return { background: "#FFF3CD", color: "#8B6200", border: "1px solid #FFD875" };
    if (s === "overdue")
      return { background: "#FFE4E6", color: "#9F1239", border: "1px solid #FDA4AF" };
    return { background: "#F0F3F6", color: "#4A5568", border: "1px solid #CBD5E0" };
  };

  const displaySection = () => {
    /* ── INVOICE LIST ── */
    if (pathname.includes("invoice")) {
      return (
        <div style={{ padding: "4px" }}>
          <div style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #E8ECF0" }}>
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                padding: "12px 16px",
                borderBottom: "1px solid #E8ECF0",
                background: "#fff",
              }}
            >
              {[
                { key: "all", label: "All invoices" },
                { key: "placement", label: "Placement & jobs" },
                { key: "subscription", label: "Workbrook Pro" },
              ].map(({ key, label }) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => {
                    setInvoiceListFilter(key);
                    setInvoicePage(1);
                  }}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "8px",
                    border:
                      invoiceListFilter === key
                        ? "1px solid #1d4ed8"
                        : "1px solid #E8ECF0",
                    background: invoiceListFilter === key ? "#eff6ff" : "#fff",
                    color: invoiceListFilter === key ? "#1d4ed8" : "#4B5563",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: "pointer",
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
            <SectionHeader text="Invoices" />
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead style={styles.thead}>
                  <tr>
                    <th style={styles.th}>Job Title</th>
                    <th style={styles.th}>Invoice No.</th>
                    <th style={styles.th}>Status</th>
                    <th style={styles.th}>Type</th>
                  </tr>
                </thead>
                <tbody style={{ background: "#fff" }}>
                  {invoices.map((invoice, i) => (
                    <tr
                      key={invoice.id}
                      onClick={() => handleRowClick(invoice.id)}
                      style={styles.trHover}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#F7F9FB")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                    >
                      <td style={styles.td}>{invoice.jobtitle}</td>
                      <td style={{ ...styles.tdSub, fontFamily: "monospace", letterSpacing: "0.03em" }}>
                        {invoice.invoice_number}
                      </td>
                      <td style={styles.tdSub}>
                        <span
                          style={{
                            ...styles.badge,
                            ...statusStyle(invoice.status),
                          }}
                        >
                          {invoice.status}
                        </span>
                      </td>
                      <td style={styles.tdSub}>{invoice.payment_type}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {invoices.length === 0 && (
                <div style={{ padding: "32px", textAlign: "center", color: "#8A96A3", fontSize: "13px" }}>
                  No invoices found.
                </div>
              )}
            </div>
          </div>

          {/* Pagination for Invoices */}
          {invoiceTotalPages > 1 && (
            <div style={{ marginTop: "16px" }}>
              <Pagination
                currentPage={invoicePage}
                totalPages={invoiceTotalPages}
                onPageChange={handleInvoicePageChange}
              />
            </div>
          )}
        </div>
      );
    }

    /* ── ACTIVE SUBSCRIPTIONS ── */
    if (pathname.includes("active")) {
      const sub = mySubscription;
      const plan = sub?.plan;
      const isProHunter = sub?.tier === "pro_hunter";
      const isSprintPack = sub?.tier === "sprint_pack";

      return (
        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            <h1 style={styles.headerTitle}>My Subscriptions</h1>
          </div>

          {/* Plan Card */}
          <div style={styles.dashboardCard}>
            <div style={styles.dashboardHeader}>
              <div style={styles.dashboardPlanName}>
                <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
                  Plan: {plan?.name || "Freemium"}
                </h2>
                {isProHunter && <span style={styles.proBadge}>Verified Pro</span>}
              </div>
            </div>

            {/* Next Billing Date (Pro Hunter) */}
            {isProHunter && sub?.expiry_date && (
              <div style={styles.billingInfo}>
                <div style={styles.billingLabel}>Next Billing Date</div>
                <p style={styles.billingValue}>
                  Your plan renews on {formatDate(sub.expiry_date)} for{" "}
                  {currencySymbol}
                  {parseFloat(plan?.price_ngn || 0).toLocaleString()}
                </p>
              </div>
            )}

            {/* Cancelled but still active banner */}
            {sub?.cancel_at_period_end && isProHunter && (
              <div
                style={{
                  ...styles.billingInfo,
                  background: "#FFF3CD",
                  border: "1px solid #FFD875",
                }}
              >
                <div style={styles.billingLabel}>Subscription Cancelled</div>
                <p style={styles.billingValue}>
                  You'll retain Pro access until {formatDate(sub.expiry_date)}
                </p>
              </div>
            )}

            {/* Credits Display (Sprint Pack) */}
            {isSprintPack && (
              <div style={styles.creditsDisplay}>
                <p style={styles.creditsNumber}>{sub.credits_remaining ?? 0}</p>
                <p style={styles.creditsLabel}>Credits Remaining</p>
              </div>
            )}

            {/* Active Benefits Tracker */}
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "700",
                marginBottom: "16px",
                color: "#1E2329",
              }}
            >
              Active Benefits
            </h3>
            <div style={styles.benefitsGrid}>
              {isProHunter && (
                <>
                  <div style={styles.benefitCard}>
                    <div style={styles.benefitIcon}>
                      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span style={styles.benefitText}>
                      Unlimited Off-Platform Matches
                    </span>
                  </div>
                  <div style={styles.benefitCard}>
                    <div style={styles.benefitIcon}>
                      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span style={styles.benefitText}>
                      Unlimited Deep Peer Insights
                    </span>
                  </div>
                  <div style={styles.benefitCard}>
                    <div style={styles.benefitIcon}>
                      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span style={styles.benefitText}>
                      Unlimited AI Resume Rewrites
                    </span>
                  </div>
                </>
              )}
              {isSprintPack && (
                <>
                  <div style={styles.benefitCard}>
                    <div style={styles.benefitIcon}>
                      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span style={styles.benefitText}>
                      Credit-Based Off-Platform Matches
                    </span>
                  </div>
                  <div style={styles.benefitCard}>
                    <div style={styles.benefitIcon}>
                      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span style={styles.benefitText}>
                      1 Credit Each Peer Insights
                    </span>
                  </div>
                </>
              )}
              <div style={styles.benefitCard}>
                <div style={styles.benefitIcon}>
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="#059669"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span style={styles.benefitText}>
                  {plan?.data_retention_days || 7} Days Data Retention
                </span>
              </div>
            </div>

            {/* Action Buttons */}
            {isSprintPack && (
              <div style={styles.actionButtons}>
                <CustomButton
                  additionalClass="p-3"
                  text={`Buy 10 More Credits — ${currencySymbol}${(() => {
                    const sp = plans?.find((p) => p.tier === "sprint_pack");
                    return sp ? getDisplayPrice(sp) : (currencySymbol === "₦" ? "15,000" : "9.99");
                  })()}`}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  handleClick={() => {
                    const sprintPlan = plans?.find(
                      (p) => p.tier === "sprint_pack",
                    );
                    if (sprintPlan) handleSubscribePlan(sprintPlan.id);
                  }}
                  loading={subscribing}
                />
                <CustomButton
                  additionalClass="p-3"
                  text="Upgrade to Pro Hunter"
                  backgroundColor="#fff"
                  color="#3A6ED4"
                  border="2px solid #3A6ED4"
                  handleClick={() => {
                    const proPlan = plans?.find((p) => p.tier === "pro_hunter");
                    if (proPlan) handleSubscribePlan(proPlan.id);
                  }}
                  loading={subscribing}
                />
                <CustomButton
                  additionalClass="p-3"
                  text="Downgrade to Freemium"
                  backgroundColor="#fff"
                  color="#6B7785"
                  border="1px solid #E8ECF0"
                  handleClick={() => {
                    const freePlan = plans?.find((p) => p.tier === "freemium");
                    if (freePlan) handleSubscribePlan(freePlan.id);
                  }}
                  loading={subscribing}
                />
              </div>
            )}
            {isProHunter && !sub?.cancel_at_period_end && (
              <div style={styles.actionButtons}>
                <CustomButton
                  additionalClass="p-3"
                  text="Cancel Subscription"
                  backgroundColor="#fff"
                  color="#DC2626"
                  border="1px solid #DC2626"
                  handleClick={() => setShowCancelModal(true)}
                  loading={cancelling}
                />
                <CustomButton
                  additionalClass="p-3"
                  text="Downgrade to Sprint Pack"
                  backgroundColor="#fff"
                  color="#3A6ED4"
                  border="2px solid #3A6ED4"
                  handleClick={() => {
                    const sprintPlan = plans?.find(
                      (p) => p.tier === "sprint_pack",
                    );
                    if (sprintPlan) handleSubscribePlan(sprintPlan.id);
                  }}
                  loading={subscribing}
                />
                <CustomButton
                  additionalClass="p-3"
                  text="Downgrade to Freemium"
                  backgroundColor="#fff"
                  color="#6B7785"
                  border="1px solid #E8ECF0"
                  handleClick={() => {
                    const freePlan = plans?.find((p) => p.tier === "freemium");
                    if (freePlan) handleSubscribePlan(freePlan.id);
                  }}
                  loading={subscribing}
                />
              </div>
            )}
            {isProHunter && sub?.cancel_at_period_end && (
              <div style={styles.actionButtons}>
                <CustomButton
                  additionalClass="p-3"
                  text="Reactivate Pro Hunter"
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  handleClick={() => {
                    const proPlan = plans?.find((p) => p.tier === "pro_hunter");
                    if (proPlan) handleSubscribePlan(proPlan.id);
                  }}
                  loading={subscribing}
                />
              </div>
            )}
          </div>
        </div>
      );
    }

    /* ── RECRUITERS ── */
    if (pathname.includes("recruiters")) {
      return (
        <div style={{ padding: "4px" }}>
          {recruiterSubscriptions.length > 1 && (
            <div style={styles.recruiterCard}>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#1E2329" }}>
                  {recruiterSubscriptions[0].description}
                </p>
              </div>
              <div style={{ flexShrink: 0, minWidth: "130px" }}>
                <CustomButton
                  additionalClass="p-3"
                  text={`PAY $${recruiterSubscriptions[0].amount}`}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  handleClick={() => handleSubscribe(recruiterSubscriptions[0].id)}
                  loading={loading}
                />
              </div>
            </div>
          )}

          <div style={styles.checkedRow}>
            <img src={Checked} alt="checked" style={{ marginTop: "2px", flexShrink: 0 }} />
            <span>
              You can only send requests to <strong>2 recruiters</strong> per recruiter access. If
              a recruiter declines, you get refunded{" "}
              <strong>{getCurrencySymbol(userData?.country)}99</strong> back into your wallet.
            </span>
          </div>
        </div>
      );
    }

    /* ── PLACEMENT FEE ── */
    if (pathname.includes("placement-fee")) {
      return (
        <div style={{ padding: "4px" }}>
          <div style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #E8ECF0" }}>
            <SectionHeader text="Pending Placement Fees" />
            <div style={{ background: "#F7F9FB", padding: "20px", borderRadius: "0 0 10px 10px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {pendingPlacementFees.results.map((recruitment) => (
                  <div key={recruitment.id} style={styles.placementCard}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "16px" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px", flex: 1 }}>
                        {[
                          { label: "Applicant", value: recruitment.applicant_name },
                          { label: "Position", value: recruitment.position || "N/A" },
                          { label: "Organisation", value: recruitment.organisation || "N/A" },
                          {
                            label: "Salary",
                            value: `${getCurrencySymbol(userData?.country)}${parseFloat(recruitment.salary).toLocaleString()}`,
                          },
                          {
                            label: "Placement Fee",
                            value: `${getCurrencySymbol(userData?.country)}${parseFloat(recruitment.placement_fee || 0).toLocaleString()}`,
                          },
                          {
                            label: "Poster Balance",
                            value: `${getCurrencySymbol(userData?.country)}${parseFloat(recruitment.job_poster_wallet_balance).toLocaleString()}`,
                          },
                        ].map(({ label, value }) => (
                          <div key={label}>
                            <div style={styles.placementLabel}>{label}</div>
                            <p style={styles.placementValue}>{value}</p>
                          </div>
                        ))}
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "12px", flexShrink: 0 }}>
                        <span style={{ ...styles.badge, ...statusStyle(recruitment.status) }}>
                          {recruitment.status.toUpperCase()}
                        </span>
                        <CustomButton
                          additionalClass="p-3"
                          text={isLoading ? "Processing..." : "Pay Now"}
                          backgroundColor="#3A6ED4"
                          color="#fff"
                          handleClick={() => handlePayNow(recruitment)}
                          loading={isLoading}
                          disabled={isLoading || recruitment.status !== "pending"}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                {pendingPlacementFees.results.length === 0 && (
                  <EmptyState text="No pending placement fees" />
                )}
              </div>
            </div>
          </div>

          {pendingPlacementFees.total > pendingPlacementFees.per_page && (
            <div style={{ marginTop: "16px" }}>
              <Pagination
                currentPage={pendingPlacementFees.current_page}
                totalPages={Math.ceil(
                  pendingPlacementFees.total / pendingPlacementFees.per_page
                )}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      );
    }

    /* ── POST A JOB (default) ── */
    return (
      <div style={{ padding: "4px" }}>
        <div style={styles.freeCard}>
          <div style={styles.freeIcon}>
            {/* briefcase icon */}
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
              <rect x="2" y="7" width="20" height="14" rx="2" stroke="#fff" strokeWidth="2" />
              <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" stroke="#fff" strokeWidth="2" />
              <line x1="12" y1="12" x2="12" y2="16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
              <line x1="2" y1="12" x2="22" y2="12" stroke="#fff" strokeWidth="2" />
            </svg>
          </div>
          <div>
            <p style={{ margin: 0, fontSize: "13px", fontWeight: "700", color: "#1E2329" }}>
              Free For Now
            </p>
            <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#6B7785" }}>
              Posting a job on the referral timeline is free for now.
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Layout>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
        .sub-menu-container, .main-content, .main-content * {
          font-family: 'DM Sans', sans-serif;
        }
      `}</style>
      <div className="position-relative d-flex flex-column flex-md-row mt-3">
        <div className="sub-menu-container">
          <BackButton />
          <SubMenu menuOptions={subMenuOptions} />
        </div>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100">
            <SectionLoader />
          </div>
        ) : (
          <div className="main-content ml-md-4 flex-grow-1">
            <Card additionalClass="position-relative py-4 w-100">
              <div style={{ padding: "0 4px" }}>
                {displaySection()}
              </div>
            </Card>
          </div>
        )}

        {/* Cancel Modal (Pro Hunter only) */}
        {showCancelModal && (
          <div
            style={styles.cancelModal}
            onClick={() => setShowCancelModal(false)}
          >
            <div
              style={styles.cancelModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={styles.cancelModalTitle}>
                Are you sure you want to cancel?
              </h3>
              <div style={styles.cancelModalBody}>
                <p style={{ marginBottom: "12px" }}>
                  We're sorry to see you go. If you cancel:
                </p>
                <ul style={{ paddingLeft: "20px", marginBottom: "12px" }}>
                  <li>
                    You'll retain Pro access until{" "}
                    {formatDate(mySubscription?.expiry_date)}
                  </li>
                  <li>You can resubscribe at any time</li>
                </ul>
                <p style={{ marginBottom: 0 }}>
                  <strong>Special Offer:</strong> Switch to Sprint Pack instead
                  and keep access to essential features at a lower price.
                </p>
              </div>
              <div style={styles.cancelModalActions}>
                <CustomButton
                  additionalClass="p-3"
                  text="Keep Subscription"
                  backgroundColor="#fff"
                  color="#3A6ED4"
                  border="1px solid #3A6ED4"
                  handleClick={() => setShowCancelModal(false)}
                />
                <CustomButton
                  additionalClass="p-3"
                  text={cancelling ? "Processing..." : "Confirm Cancellation"}
                  backgroundColor="#DC2626"
                  color="#fff"
                  handleClick={handleCancel}
                  loading={cancelling}
                />
              </div>
            </div>
          </div>
        )}

        {/* Fund Wallet Modal */}
        {showFundWalletModal && (
          <div
            style={styles.cancelModal}
            onClick={() => setShowFundWalletModal(false)}
          >
            <div
              style={styles.cancelModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={styles.cancelModalTitle}>
                Insufficient Wallet Balance
              </h3>
              <div style={styles.cancelModalBody}>
                <p>
                  You don't have enough balance to subscribe to this plan.
                  Please fund your wallet and try again.
                </p>
              </div>
              <div style={styles.cancelModalActions}>
                <CustomButton
                  additionalClass="p-3"
                  text="Maybe Later"
                  backgroundColor="#fff"
                  color="#6B7785"
                  border="1px solid #E8ECF0"
                  handleClick={() => setShowFundWalletModal(false)}
                />
                <CustomButton
                  additionalClass="p-3"
                  text="Fund Wallet"
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  handleClick={() => {
                    setShowFundWalletModal(false);
                    history.push("/wallet/add");
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Subscriptions;